import { PlannedActivityClient } from "../services/ohl.virtualCenter.api";
import moment from 'moment';

const apiClient = new PlannedActivityClient(process.env.REACT_APP_PUBLIC_API);

class PlannedActivitiesProvider {

    prepareActivities = (plannedActivitiesList) => {
        const cleanList = JSON.parse(JSON.stringify(plannedActivitiesList));

        cleanList.forEach(act => {
            if (act.contracts) {
                act.contracts.forEach(c => {
                    delete c.initialDate;
                    delete c.endDate;
                    delete c.extensionDuration;
                });
            }
            if (act.participants) {
                act.participants.forEach(p => {
                    delete p.birthDate;
                    delete p.activeDate;
                    delete p.leavingDate;
                    delete p.inactivityDate;
                    delete p.setupDate;
                    delete p.veraAppVersionDate;
                    delete p.dateOfFirstVisit;
                    delete p.contractSigningDate;
                    delete p.contractExpirationDate;
                });
            }
        });

        return cleanList;
    }

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        
        return apiClient.list({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }

    initialProcess = (data) => {
        if (data.startDate) {
            data.startDate = moment(data.startDate).format('yyyy-MM-DDTHH:mm:ss')
        }

        if (data.endDate) {
            data.endDate = moment(data.endDate).format('yyyy-MM-DDTHH:mm:ss')
        }

        return apiClient.initialProcess(data).then((data) => {
            // Devolvemos el PlanningProcessDto directamente
            return {
                data: data
            }
        });
    }

    
    getPlanningProcess = (id) => {
        return apiClient.planningProcess(id).then((data) => {
            return { data };
        });
    }
    
    getProposals = (id) => {
        // CORREGIDO: NSwag ha bautizado la función como 'proposals'
        return apiClient.proposals(id).then((data) => {
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }
    
    getActivePlanningProcess = () => {
       
        
        return apiClient.active().then((data) => {
            return { data };
        }).catch(() => {
            // Si el backend devuelve un 204 No Content, a veces Axios/fetch lo lanza por el catch
            return { data: null };
        });
    }

    saveActivities = (plannedActivitiesList, planningProcessId) => {
        const cleanList = this.prepareActivities(plannedActivitiesList);
        return apiClient.plannedActivity({ planningProcessId, plannedActivities: cleanList }).then((data) => {
            return {
                data: data?.elements || [],
                total: data?.total || 0,
            };
        });
    }

    startActivityCreation = (plannedActivitiesList, planningProcessId) => {
        const cleanList = this.prepareActivities(plannedActivitiesList);
        return apiClient.activityCreationStart(
            planningProcessId,
            { planningProcessId, plannedActivities: cleanList }
        ).then((data) => ({ data }));
    }

    getActivityCreationProgress = (planningProcessId) => {
        return apiClient.activityCreationProgress(planningProcessId).then((data) => ({ data }));
    }

    cancelActivityCreation = (planningProcessId) => {
        return apiClient.activityCreationCancel(planningProcessId).then((data) => ({ data }));
    }

    updateProcessStatus = (processId, statusName) => {
        return apiClient.status(processId, { status: statusName, errorMessage: "" }).then(() => {
            return true;
        });
    }

};

export default new PlannedActivitiesProvider();
